export default __webpack_public_path__ + "a4088c5a64558e1a87168126c6703bfc.svg";